import MyTeam from './MyTeam';

const Teams = () => {
  return <MyTeam />;
};

export default Teams;
